import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ngx-text-editor',
  templateUrl: './text-editor-input.component.html',
  styleUrls: ['./text-editor-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextEditorInputComponent),
      multi: true,
    },
  ],
})
export class TextEditorInputComponent implements OnInit, ControlValueAccessor, AfterViewInit {
  @Input() _inputValue = undefined;
  @Input() label = '';

  @Output() inputValid = new EventEmitter<boolean>();
  @ViewChild('child', { static: false }) feild: ElementRef;

  ngOnInit() {}
  constructor() {}
  get inputValue() {
    return this._inputValue;
  }

  set inputValue(val) {
    this._inputValue = val;
    this.propagateChange(this._inputValue);
  }
  propagateChange = (_: any) => {};
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched() {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.feild && this.feild.nativeElement) this.inputValid.emit(this.feild.nativeElement.validity.valid);
    });
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.inputValue = value;
    }
  }

  public toolbarSettings: object = {
    items: ['Formats', 'FontColor', 'Alignments', 'OrderedList', 'UnorderedList', 'Undo', 'Redo'],
  };
}
